import { v } from "overshom-valid";

class TypedEnv extends v.class({
  REACT_APP_ENV_NAME: v.String(),
  REACT_APP_API_URL: v.String(),
  REACT_APP_AUTH_API_URL: v.String(),
  REACT_APP_AUTH_LINK: v.String(),
}) {}

export const buildEnv = (obj: any) => new TypedEnv(obj);

export const env = buildEnv(process.env);

export const IS_NOT_PROD_ENV = env.REACT_APP_ENV_NAME !== "production";
